import { Component, OnInit, HostBinding } from '@angular/core';
import {Title, Meta} from '@angular/platform-browser';
import {AnimationsMetaData} from '../../_animations/animations.metadata';
import {Subscription} from 'rxjs/Subscription';
import {AnimationService} from '../../_animations/animations.service';
import {RouteDirections, IRouteDirection} from '../../_animations/route-directions.constant';

@Component({
  selector: 'app-infringementreport',
  providers: [AnimationService, RouteDirections],
  templateUrl: './infringement-report.component.html',
  styleUrls: ['./infringement-report.component.css'],
  animations: [AnimationsMetaData]
})
export class InfringementReportComponent implements OnInit {
  @HostBinding('@routing') routing;
  @HostBinding('style.display') display = 'block';
  animationServiceEventsSubscription: Subscription;
  public routeDirections: IRouteDirection[];

  constructor(private Title: Title,
              private Meta: Meta,
              private animationService: AnimationService,
              routeDirections: RouteDirections) {
    this.routeDirections = routeDirections.infringementreport;
  }

  ngOnInit() {
    this.Title.setTitle('Infringement.Report - Work | Alec Bertram');
    this.Meta.addTag({name: 'description', content: 'Infringement.Report is an image usage discovery and monitoring platform which is used by niche law firms and brands to track where their image assets are being used.'});
    this.routing = this.animationService.animationDirection();
    this.animationServiceEventsSubscription = this.animationService.emitCurrentDirection
      .subscribe((direction: any) => this.routing = direction);
  }

  go(direction: string, url: string) {
    return this.animationService.routingService(direction, url);
  }
  pan($event, url: string) {
    return this.animationService.mobileRoutingSerivce($event, url);
  }
}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/work/infringement-report/infringement-report.component.ts